import { useState } from 'react'
import { Link } from 'react-router'
import { X, MailWarning } from 'lucide-react'
import type { UserProfile } from '@/lib/types'

interface Props {
  profile: UserProfile | null
  dismissible?: boolean
}

export function EmailVerificationBanner({ profile, dismissible = false }: Props) {
  const dismissedKey = profile ? `email_banner_dismissed_${profile.id}` : null
  const [dismissed, setDismissed] = useState(() =>
    dismissible && dismissedKey ? sessionStorage.getItem(dismissedKey) === '1' : false
  )

  if (!profile || profile.is_email_verified || dismissed) return null

  const handleDismiss = () => {
    if (dismissedKey) sessionStorage.setItem(dismissedKey, '1')
    setDismissed(true)
  }

  return (
    <div className="flex items-center gap-3 px-4 py-2.5 bg-secondary text-[#0D0D0D] text-sm shrink-0">
      <MailWarning className="h-4 w-4 shrink-0" />
      <p className="flex-1 leading-snug">
        Your email address is not verified.{' '}
        <Link to="/dashboard/settings" className="font-semibold underline hover:no-underline">
          Go to Settings to verify →
        </Link>
      </p>
      {dismissible && (
        <button
          onClick={handleDismiss}
          aria-label="Dismiss notification"
          className="shrink-0 hover:opacity-60 transition-opacity"
        >
          <X className="h-4 w-4" />
        </button>
      )}
    </div>
  )
}
